const NotificationObjectClassEnum = Object.freeze({
    INVESTOR: 'INVESTOR',
    INVESTOR_MEDIA_LIBRARY: 'INVESTOR_MEDIA_LIBRARY',
    INVESTOR_MEDIA: 'INVESTOR_MEDIA',
    ADVISER: 'ADVISER',
    OFFER: 'OFFER',
    PROPOSAL: 'PROPOSAL',
    SHORTLIST: 'SHORTLIST'
});

export default NotificationObjectClassEnum;
